/**
 * Cookie Utilities
 * Unified session and cookie management for store-front
 */

import Cookies from 'js-cookie';

import { SessionData } from '../store/types';

const SESSION_COOKIE_NAME = 'session';
const SESSION_CREATED_COOKIE_NAME = 'session_created';

const COOKIE_OPTIONS = {
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'strict' as const,
};

/**
 * Get session data from cookie
 */
export const getSessionCookie = (): SessionData | null => {
    const cookie = Cookies.get(SESSION_COOKIE_NAME);
    if (!cookie) return null;

    try {
        return JSON.parse(cookie);
    } catch {
        return null;
    }
};

/**
 * Set session data in cookie
 */
export const setSessionCookie = (data: SessionData): void => {
    Cookies.set(SESSION_COOKIE_NAME, JSON.stringify(data), COOKIE_OPTIONS);
    Cookies.set(SESSION_CREATED_COOKIE_NAME, String(Date.now()), COOKIE_OPTIONS);
};

/**
 * Remove session cookie
 */
export const removeSessionCookie = (): void => {
    Cookies.remove(SESSION_COOKIE_NAME);
    Cookies.remove(SESSION_CREATED_COOKIE_NAME);
};

/**
 * Check if session cookie exists
 */
export const hasSessionCookie = (): boolean => {
    return !!Cookies.get(SESSION_COOKIE_NAME);
};
